import c from "../../utils/constants";
import common from "../../utils/common";

class CertificatesController {
  constructor(CertificatesService, FilterService, AuthService, $scope) {
    "ngInject"

    this.certificatesService = CertificatesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.certificatesReviewStatusOptions = {
      dataSource: [
        { value: 1, text: "Pending Verification" },
        { value: 2, text: "Active" },
        { value: 3, text: "Invalid" },
        { value: 4, text: "Expired" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    }

    this.certificatesTypeOptions = {
      valuePrimitive: true,
      dataSource: [
        { value: 0, text: "Unspecified" },
        { value: 1, text: "Volunteer" },
        { value: 2, text: "Paid" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    }

  }

  getGridOptions() {

    return {
      dataSource: this.certificatesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No Certificates."
      },
      columns: [
        {
          field: "fullName", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "8rem",
          template: (dataItem) => `<a class="cell" href="/users/${dataItem.jugglerId}">${dataItem.fullName}</a>`,
        },
        { field: "officialFullName", title: "Legal Name", filterable: false, sortable: false, width: "8rem" },
        { field: "creationDate", title: "Upload Date", filterable: false, sortable: false, width: "4rem", template: `#= creationDate ? kendo.toString(new Date(creationDate), 'dd/MM/yyyy'): '-' #` },
        { field: "dateOfBirth", title: "Date of Birth", filterable: false, sortable: false, width: "4rem", template: `#= dateOfBirth ? kendo.toString(new Date(dateOfBirth), 'dd/MM/yyyy'): '-' #` },
        // { field: "category", title: "Category", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCategory(dataItem.category)}` },
        { field: "certificateTypeId", title: "Certificate Type", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCertificateType(dataItem.certificateTypeId)}` },
        { field: "addressState", title: "State", filterable: false, sortable: false, width: "4rem" },
        { field: "certificateNumber", title: "Certificate Number", filterable: false, sortable: false, width: "4rem" },
        { field: "certificateStatus", title: "Certificate Status", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getCertificateStatus(dataItem.certificateStatus)}` },
        { field: "expiryDate", title: "Expiry Date", filterable: false, width: "4rem", sortable: false, template: `#= expiryDate ? kendo.toString(new Date(expiryDate), 'dd/MM/yyyy'): '-' #` },
        // { field: "verificationDate", title: "Verification Date", filterable: false, sortable: false, width: "4rem", template: `#= verificationDate ? kendo.toString(new Date(verificationDate), 'dd/MM/yyyy'): '-' #` },
        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Update Certificate Status" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.certificatesMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getCertificateStatus(status) {
    switch(status) {
      case c.certificateStatus.PENDINGVERIFICATION:
        return "Pending Verification";
      case c.certificateStatus.ACTIVE:
        return "Active";
      case c.certificateStatus.INVALID:
        return "Invalid";
      case c.certificateStatus.EXPIRED:
        return "Expired";
    }
  }

  _getCategory(category) {
    switch(category) {
      case c.certificateCategory.CHECK:
        return "Check";
      case c.certificateCategory.FIRSTAID:
        return "First Aid";
      case c.certificateCategory.QUALIFICATION:
        return "Qualification";
    }
  }

  _getCertificateType(type) {
    switch(type) {
      case c.certificateType.WWCC:
        return "WWCC";
    }
  }

}

export default CertificatesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/certificates/certificates.controller.js
 **/